import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileService } from 'src/app/services/api/file.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-time-picker-dialog',
  templateUrl: './time-picker-dialog.component.html',
  styleUrls: ['./time-picker-dialog.component.css'],
})
export class TimePickerDialogComponent {
  hours: number[] = Array.from({ length: 24 }, (_, i) => i); // Horas 0-23
  minutes: number[] = Array.from({ length: 60 }, (_, i) => i); // Minutos 0-59

  selectedHour: number = 0;
  selectedMinute: number = 0;

  loading: boolean = false;
  success: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<TimePickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fileSercice: FileService
  ) {}

  onCancel(): void {
    this.dialogRef.close(null);
  }

  save() {
    const id = this.data.element.id || this.data.element.idActivity;
    const horaProgramada = `${this.padTime(this.selectedHour)}:${this.padTime(this.selectedMinute)}:00`;

    this.fileSercice.addPersonaExtra(id, horaProgramada).subscribe({
      next: (response) => {
        this.success = true;
        this.dialogRef.close({
          success: this.success,
          horaProgramada: horaProgramada,
        });
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Se editó la hora programada correctamente',
          showConfirmButton: false,
          timer: 3000,
        });
      },
      error: (err) => {
        console.error('Error al actualizar la hora programada:', err);
        this.loading = false;
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Ocurrio un error',
          showConfirmButton: false,
          timer: 3000,
        });
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  private padTime(value: number): string {
    return value.toString().padStart(2, '0');
  }
}
